export const greeks = ['delta', 'gamma', 'rho', 'theta', 'vega'] as const;
